import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			opacity: .3,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M6 19C6 11.8203 11.8203 6 19 6C26.1797 6 32 11.8203 32 19C32 26.1797 26.1797 32 19 32C11.8203 32 6 26.1797 6 19Z",
				stroke: "#1570EF",
				strokeWidth: 2
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .1,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M1 19C1 9.05888 9.05888 1 19 1C28.9411 1 37 9.05888 37 19C37 28.9411 28.9411 37 19 37C9.05888 37 1 28.9411 1 19Z",
				stroke: "#1570EF",
				strokeWidth: 2
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 22.3337V19.0003M19 15.667H19.0083M27.3333 19.0003C27.3333 23.6027 23.6024 27.3337 19 27.3337C14.3976 27.3337 10.6667 23.6027 10.6667 19.0003C10.6667 14.398 14.3976 10.667 19 10.667C23.6024 10.667 27.3333 14.398 27.3333 19.0003Z",
			stroke: "#1570EF",
			strokeWidth: 1.66667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAlertInfo;
